import { render } from "./Reasons.vue?vue&type=template&id=64903718"
import script from "./Reasons.vue?vue&type=script&lang=js"
export * from "./Reasons.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/Reasons.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "64903718"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('64903718', __exports__)) {
    api.reload('64903718', __exports__)
  }
  
  module.hot.accept("./Reasons.vue?vue&type=template&id=64903718", () => {
    api.rerender('64903718', render)
  })

}


export default __exports__